import { upperFirst, words } from 'lodash';

export const mergeClassNames = (...classNames) => classNames.filter(i => i).join(' ');

export const mapObjectsByAttr = (objectList = [], attr) => {
    const mapped = {};
    objectList
        .map(obj => [obj[attr], obj])
        .forEach(([key, obj]) => (mapped[key] = obj));
    return mapped;
};

const filterUnknowns = value => value !== 'UNKNOWN';

export const mergeStringsWithSpaces = list =>
    list.filter(Boolean).filter(filterUnknowns).join(' ');

export const deslugify = slug => (slug ? slug.replace(/-/g, ' ').replace(/_/g, ' ') : '');

export const deCamelify = text => text.replace(/([a-z])([A-Z])/g, '$1 $2');

export const titleCase = value => words(value).map(i => upperFirst(i)).join(' ');
